import { supabase } from "@/integrations/supabase/client";
import type { Profile } from "@/lib/db/models";

export const profileService = {
  async getMyProfile(userId: string): Promise<Profile | null> {
    const { data, error } = await supabase
      .from("profiles")
      .select("*")
      .eq("id", userId)
      .maybeSingle();
    if (error) throw error;
    return (data as Profile) ?? null;
  },

  async updateMyProfile(userId: string, patch: Partial<Profile>) {
    const { data, error } = await supabase
      .from("profiles")
      .update(patch as never)
      .eq("id", userId)
      .select()
      .single();
    if (error) throw error;
    return data as Profile;
  },
};
